<template>
  <div class="form billing">
    <div v-if="errors" class="form-field" :class="{ 'error' : errors }">
      {{ errors }}
    </div>

    <div class="form-field custom">
      <div class="custom-checkbox-radio">
        <input type="checkbox" v-model="copyShipping" />
        <label for>Are Billing details the same as Shipping?</label>
      </div>
    </div>

    <div>
      <div v-show="!copyShipping">
        <ValidationObserver
          tag="div" class="form-wrap"
          v-slot="{ invalid }"
        >
          <div class="form-fields-stack">
            <ValidationProvider
              tag="div" class="form-field"
              name="First Name" rules="required" v-slot="{ errors }"
            >
              <label>First Name</label>
              <input type="text" v-model="payload.first_name" id="firstname" >
              <span class="validate" v-if="errors[0]">{{ errors[0] }}</span>
            </ValidationProvider>

            <ValidationProvider
              tag="div" class="form-field"
              name="Last Name" rules="required" v-slot="{ errors }"
            >
              <label>Last Name</label>
              <input type="text" v-model="payload.last_name" id="lastname" >
              <span class="validate" v-if="errors[0]">{{ errors[0] }}</span>
            </ValidationProvider>
          </div>

          <div class="form-fields-stack">
            <ValidationProvider
              tag="div" class="form-field"
              name="Phone Number" rules="required" v-slot="{ errors }"
            >
              <label>Phone Number</label>
              <input type="text" v-model="payload.phone" id="phone" >
              <span class="validate" v-if="errors[0]">{{ errors[0] }}</span>
            </ValidationProvider>

            <ValidationProvider
              tag="div" class="form-field"
              name="email" rules="required" v-slot="{ errors }"
            >
              <label>Email Address</label>
              <input type="text" v-model="payload.email" id="email_address">
              <span class="validate" v-if="errors[0]">{{ errors[0] }}</span>
            </ValidationProvider>
          </div>

          <legend>Address</legend>

          <ValidationProvider
            tag="div" class="form-field"
            name="Street Address" rules="required" v-slot="{ errors }"
          >
            <label>Street Address</label>
            <input type="text" v-model="payload.address1" id="address1">
            <span class="validate" v-if="errors[0]">{{ errors[0] }}</span>
          </ValidationProvider>

          <div class="form-fields-stack three-quarters">
            <ValidationProvider
              tag="div" class="form-field"
              name="Suburb" rules="required" v-slot="{ errors }"
            >
              <label>Suburb</label>
              <input type="text" v-model="payload.suburb" id="address2">
              <span class="validate" v-if="errors[0]">{{ errors[0] }}</span>
            </ValidationProvider>

            <ValidationProvider
              tag="div" class="form-field"
              name="City" rules="required" v-slot="{ errors }"
            >
              <label>City</label>
              <input type="text" v-model="payload.city" id="city">
              <span class="validate" v-if="errors[0]">{{ errors[0] }}</span>
            </ValidationProvider>
          </div>

          <div class="form-fields-stack">
            <ValidationProvider
              tag="div" class="form-field"
              name="Post Code" rules="required" v-slot="{ errors }"
            >
              <label>Post Code</label>
              <input type="text" v-model="payload.post_code" id="post_code">
              <span class="validate" v-if="errors[0]">{{ errors[0] }}</span>
            </ValidationProvider>

            <div class="form-field select">
              <label>Country</label>
              <select v-model="payload.country_id">
                <option
                  v-for="country of countries" :key="country.id"
                  :value="country.id"
                >
                  {{ country.title }}
                </option>
              </select>
            </div>

            <!-- <div class="form-field select">
                <label>Delivery Requirement</label>
                <select
                    v-model="payload.region_id"
                >
                    <option v-for="region of regions" :key="region.id" :value="region.id">{{ region.name }}</option>
                </select>
            </div> -->

          </div>
        </ValidationObserver>
      </div>

      <div class="checkout-step-footer">
        <button @click="goBack" class="button black large" :disabled="disableButton">BACK</button>
        <button @click="savePayload" class="button black large" :disabled="disableButton">NEXT STEP</button>
      </div>
    </div>

  </div>
</template>

<script>
  export default {
    props: {
      countries: Array,
      regions: Array,
      cart: Object
    },
    data() {
      return {
        disableButton: false,
        copyShipping: false,
        payload: {},
        errors: ''
      };
    },
    mounted () {
      this.payload = this.$store.state.cart.billingInfo
    },
    watch: {
      copyShipping (value) {
        if (value === true) {
          // this.cart.billingInfo = this.payload
          this.payload = this.$store.state.cart.shippingInfo
        }
      }
    },
    methods: {
      savePayload (e) {
        this.errors = []
        this.disableButton = true

        window.axios.post('/checkout/billing', this.payload)
        .then((res) => {
          if (res.data.success) {
            this.cart.billingInfo = this.payload
            this.$store.state.cart.billingInfo = this.payload
            this.$emit("emitStep", 3)
          }
        })
        .catch((error) => {
          this.errors = error.response.data.message
        })
        .then(() => {
          this.disableButton = false
        })
      },

      goBack () {
        this.$emit("emitStep", 1);
      }
    }
  }
</script>

<style lang="scss">
  .custom {

    .custom-checkbox-radio {
      display: flex;
      padding: 0 0 15px;

        label {
          margin-bottom: 0;
        }
    }
  }
</style>



// WEBPACK FOOTER //
// resources/assets/frontend/js/modulatte-cart/components/Billing.vue